import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

// Enregistre une consultation (POST idempotent par (user, resource)).
// Un échec ne doit pas casser l'ouverture du PDF : le container gère le rejet silencieusement.
export const documentaryResourceConsultationLog = createApiThunk<void, string>(
  "documentaryResourceConsultation/log",
  async (resourceId: string, { extra: { sharedRepository } }) => {
    return sharedRepository!.documentaryResourceConsultationLog(resourceId);
  },
);
